<template>
    <div id="app" class="appClass" :class="{'chart-only': chartOnly}" v-if="catList">
        <router-view/>
        <div id="export-div" class="sr-only"></div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import axios from 'axios';

export default {
    name: 'App',
    data () {
        return {
            chartOnly: this.$route.query.chartOnly,
            embeddedVersion: this.$route.query.embeddedVersion, 
            catList: null
        };
    },
    async mounted () {
         window.siteName = 'nihdatabook';

        function checkRedirect() {
            if (window.location.pathname && window.location.pathname.toLowerCase() === '/' + window.siteName) {
                window.location = window.location.href + '/';
            }
        }

        function addBaseURL() {
            let baseURL = window.location.origin;

            if (window.location.pathname && window.location.pathname.toLowerCase().startsWith('/' + window.siteName + '/')) {
                baseURL += '/' + window.siteName + '/';
            }

            document.head.innerHTML = document.head.innerHTML + '<base href="' + baseURL + '" />';
        }

        checkRedirect();
        addBaseURL();
        if ((document.location.search && document.location.search.includes("chartOnly"))) {
            $(".appClass").addClass("chart-only");
        }
        await this.getCategoryData();
    },
    methods: {
        ...mapActions([
            'setCategoryList'
        ]),
        async getCategoryData () {
            let handleData;
            const url =  (window.location.hostname === 'localhost' ?  'https://localhost:59971' :  window.location.origin +  '/reportweb') + '/api/category/get';
            
            /*--------------------------------------------------------------
            * Handle user service call and other calls in init services
            *-------------------------------------------------------------*/
            handleData = (data) => {
                this.catList = data;
                this.setCategoryList(data);
            };

            await axios.get(url)
                .then(response => {
                  handleData(response.data);
                });
        }
    }
};
</script>

<style lang="scss">
@import 'scss/main';
body {
    background-color:  #fff;
}
</style>
